module.exports = __webpack_public_path__ + "apple-touch-icon-c9cf1542b738b1e28d64c35e4266d3bf.png";